import { FunctionComponent, ReactNode, useState } from 'react'
import Button, { ButtonVariant } from './Button'
import { label, prefix } from './layout/ProductTrackingIntegration'
import { Modal } from './Modal'

export type ConfirmationModalProps = {
  title: string
  message: ReactNode
  trackingLabel: `${prefix}-${label}`
  confirmVariant?: ButtonVariant
  onCancel: () => void
  onConfirm: () => void | Promise<void>
}

export const ConfirmationModal: FunctionComponent<ConfirmationModalProps> = ({ title, message, trackingLabel, confirmVariant = 'primary', onCancel, onConfirm }) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleConfirm = async () => {
    if (isLoading) return
    setIsLoading(true)
    await onConfirm()
  }

  return (
    <Modal.Content>
      <Modal.Title>{title}</Modal.Title>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Actions>
        <Button variant="tertiary" onClick={onCancel} disabled={isLoading} trackingLabel={`${trackingLabel}-cancel`}>
          Cancel
        </Button>

        <Button variant={confirmVariant} onClick={handleConfirm} disabled={isLoading} iconName={isLoading ? 'pubstack' : undefined} iconSpin={isLoading} trackingLabel={`${trackingLabel}-apply`}>
          Confirm
        </Button>
      </Modal.Actions>
    </Modal.Content>
  )
}
